import React from 'react';
import BootstrapTooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import PropTypes from 'prop-types';

// TODO: Delete this stylesheet once all pages that use Tooltip component are using Bootstrap 5
import './tooltip.scss';

const Tooltip = ({
  message,
  children,
  id = 'tooltip',
  placement = 'top',
  show,
}) => {
  if (!message || !children) {
    throw new Error('Please provide all required props');
  }

  return (
    <OverlayTrigger
      placement={placement}
      show={show}
      overlay={(props) => (
        <BootstrapTooltip id={id} {...props}>
          {message}
        </BootstrapTooltip>
      )}
    >
      {children}
    </OverlayTrigger>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  id: PropTypes.string,
  placement: PropTypes.string,
  show: PropTypes.bool,
};

export default Tooltip;
